import React from 'react';

export type ResetPasswordData = {
  isCreatingPasswordReset: boolean;
  isUpdatingPassword: boolean;
  notification?: string;
  error?: string;
  username?: string;
  password?: string;
  confirmPassword?: string;
};

export const DEFAULT_RESET_PASSWORD_DATA: ResetPasswordData = {
  isCreatingPasswordReset: false,
  isUpdatingPassword: false,
};

type ResetPasswordDataContextValue = {
  resetPasswordData: ResetPasswordData;
  setResetPasswordData: React.Dispatch<React.SetStateAction<ResetPasswordData>>;
};

export const ResetPasswordDataContext = React.createContext<ResetPasswordDataContextValue>({
  resetPasswordData: DEFAULT_RESET_PASSWORD_DATA,
  setResetPasswordData: () => null,
});
